import secureLocalStorage from "react-secure-storage";
import React from "react";
import { GridCell } from "@progress/kendo-react-grid";
import { NumericTextBox } from "@progress/kendo-react-inputs";
import { formatNumber } from "@telerik/kendo-intl";

export default class RiskCustomFieldNumeric extends GridCell {
  constructor(props) {
    super(props);
    this.state = {
      temp: this.props.dataItem[this.props.field],
    };
  }
  componentDidUpdate = () => {
    if (
      this.props.dataItem.inEdit &&
      document.getElementById(this.props.field)
    ) {
      document.getElementById(this.props.field).focus();
    }
  };

  handleChange = (e) => {
    this.setState({ temp: e.value });
  };

  handleBlur = () => {
    try {
      let customFields = this.props.customFieldsData;
      let field = this.props.field;
      let options = customFields.find((item) => item.fieldName == field);

      if (options) {
        let val = {
          ...this.props.dataItem,
          [field]:this.state.temp,
          riskCustomField: {
            CustomFieldValue: options.id,
            RiskId: this.props.dataItem.riskRegisterId,
            // PossibleFieldId: this.state.temp, //e.value.id,
            MultiText:this.state.temp?this.state.temp.toString():""
          },
        };
        this.props.manageCustomValues(val);
      }
    } catch (err) {}
  };
  handleEditCell = () => {
    if (this.props.dataItem.riskRegisterId) {
      this.props.onEditCell(
        this.props.dataItem,
        this.props.field,
        this.props.stateData
      );
    }
  };
  render() {
    const { dataItem, field } = this.props;
    const userEmail = secureLocalStorage.getItem("userName");
    const owner = dataItem.owner;
    const str = this.props.dataItem[this.props.field]?.toString()||"";
    const dataValue=str.includes(",") ? str.replace(/,/g, '') : str;
    const cf=this.props.dataItem.customFields&&this.props.dataItem.customFields.find((item)=>item.fieldName == this.props.field);
    let access=false;
    if(cf){
      access=true;
    }
    if (this.props.field && this.props.field === this.props.dataItem.inEdit) {
      return (
        <td>
          <NumericTextBox
            onChange={(e) => this.handleChange(e)}
            onBlur={this.handleBlur}
            id={this.props.field}
            value={this.state.temp}
          />
        </td>
      );
    } else {
      if (userEmail === owner&&access) {
        return (
          <td title={dataValue||dataValue===0?formatNumber(parseInt(dataValue), "##,#"):""} onClick={this.handleEditCell}>
            <p>{dataValue||dataValue===0?formatNumber(parseInt(dataValue), "##,#"):""}</p>
          </td>
        );
      } else {
        return this.props.dataItem.role == "Standard User" ||
          this.props.dataItem.role == "View Only" || !access ? (
          <td title={dataValue||dataValue===0?formatNumber(parseInt(dataValue), "##,#"):""}>
            <p>{dataValue||dataValue===0?formatNumber(parseInt(dataValue), "##,#"):""}</p>
          </td>
        ) : (
          <td title={dataValue||dataValue===0?formatNumber(parseInt(dataValue), "##,#"):""} onClick={this.handleEditCell}>
            <p>{dataValue||dataValue===0?formatNumber(parseInt(dataValue), "##,#"):""}</p>
          </td>
        );
      }
    }
  }
}
